export default "__VITE_PUBLIC_ASSET__836a14b1__"